import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import messages from '../lib/messages.json';
import Layout from '../components/Layout';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import Markdown from '../components/Markdown';
import markdown from '../data/marketplace/brands.md';

const MarketplaceBrandsPage = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    intl.formatMessage(messages.brands),
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['marketplace.brands.title'])}
        description={intl.formatMessage(
          messages['marketplace.brands.description'],
        )}
      />
      <StaticPageComponent
        content={(
          <Markdown markdown={markdown} allowHtml allowGfm />
      )}
        title={intl.formatMessage(messages['marketplace.brands.title'])}
        subTitle="marketplace"
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

MarketplaceBrandsPage.getLayout = (page: ReactElement) => (
  <Layout>{page}</Layout>
);

export default MarketplaceBrandsPage;
